export const SET_ABTEILUNGEN = 'setAbteilungen';
export const SET_USERS = 'setUsers';
export const SET_DOKUMENTTYPEN = 'set_dokumenttypen';
export const SET_CURRENT_TIMESTAMP = 'set_current_timestamp';
